import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '@/utils/auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/login', name: 'Login', component: () => import('@/views/PrototypeShell.vue'), meta: { prototypePage: 'login.html' } },
    { path: '/', name: 'Home', component: () => import('@/views/PrototypeShell.vue'), meta: { prototypePage: 'login.html' } },
    { path: '/workbench', name: 'Workbench', component: () => import('@/views/PrototypeShell.vue'), meta: { prototypePage: 'company-home.html' } },
    { path: '/ua026', name: 'UA026Analysis', component: () => import('@/views/PrototypeShell.vue'), meta: { prototypePage: 'ua026-analysis.html' } },
    { path: '/ua021', name: 'UA021Analysis', component: () => import('@/views/PrototypeShell.vue'), meta: { prototypePage: 'edc021-analysis.html' } },
    { path: '/etmf', name: 'EtmfDock', component: () => import('@/views/EtmfDock.vue') },
    { path: '/ccp', name: 'CcpDock', component: () => import('@/views/CcpDock.vue') },
    { path: '/tmconnect', name: 'TmconnectDock', component: () => import('@/views/TmconnectDock.vue') },
    { path: '/edc021', name: 'Edc021Dock', component: () => import('@/views/Edc021Dock.vue') },
    { path: '*', redirect: '/workbench' }
  ]
})

router.beforeEach((to, from, next) => {
  const token = getToken()
  if (token && (to.path === '/' || to.path === '/login')) {
    const redirect = to.query.redirect
    if (typeof redirect === 'string' && redirect.startsWith('/') && !redirect.startsWith('//') && redirect !== '/' && redirect !== '/login') {
      next(redirect)
      return
    }
    next('/workbench')
    return
  }
  next()
})

export default router
